module.exports = __webpack_public_path__ + "e22fec65c92493e3467b06927b0e9e97.png";